import React from 'react';
import UserLayout from '../layout/UserLayout';

const About = () => {
  return (
    <UserLayout>
      <div>About Us</div>
    </UserLayout>
  );
};

export default About;
